import React from "react";
import { ProductFormValues } from "../../components/ProductForm/types";

export const ScreenContext = React.createContext<{
  onSubmit: (retailPrice: string) => void;
  originalFormValues: ProductFormValues;
}>({
  onSubmit: () => {},
  originalFormValues: {} as ProductFormValues,
});

export type PricingSuggestion = {
  strategy: string;
  price: number;
  gpDollarValue: number;
  markup: number;
  reasoning: string;
};
